import React from 'react'

function TermsModal({ isOpen, onClose }) {
  if (!isOpen) return null

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Terms of Use</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><strong>Effective Date:</strong> 18/06/2025</p>
            <p>These Terms of Use govern your access to and use of the FAQ platform ("the Service") provided by Thomas Andersen.</p>

            <h5>1. Use of the Service</h5>
            <p>You must be 18 or have permission from a guardian. Use the Service lawfully.</p>

            <h5>2. Accounts</h5>
            <p>You are responsible for keeping your login credentials safe.</p>

            <h5>3. User Content</h5>
            <p>You retain ownership of your created FAQs. Admins cannot access them. Admins may upload company-wide FAQs via CSV.</p>

            <h5>4. Acceptable Use</h5>
            <ul>
              <li>No illegal activity</li>
              <li>No infringement of others’ rights</li>
              <li>No malware or spam</li>
            </ul>

            <h5>5. Termination</h5>
            <p>We may suspend accounts for violations or risk.</p>

            <h5>6. Intellectual Property</h5>
            <p>The Service and branding are owned by Thomas Andersen. No redistribution allowed.</p>

            <h5>7. Limitation of Liability</h5>
            <p>We provide the Service “as is” and are not liable for indirect damages.</p>

            <h5>8. Modifications</h5>
            <p>We may update Terms and notify users. Continued use = acceptance.</p>

            <h5>9. Governing Law</h5>
            <p>German law applies.</p>

            <h5>10. Contact</h5>
            <p>
              Thomas Andersen<br />
              Marchlewskistraß 61, 10243 Berlin, Germany<br />
              Email: support@faqhelper.io
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsModal
